module.exports = __webpack_public_path__ + "static/media/logo-fitbit-iconblue.2488b451.png";